<template>
  <v-expansion-panel-header
    v-bind="$props"
    ref="expansion-panel-header"
    class="w-expansion-panel-header scrollable"
    disable-icon-rotate
    v-on="$listeners"
  >
    <template>
      <div :class="`w-expansion-panel-header__default ${getIsActiveClass()}`">
        <w-arrow-down
          :class="['w-expansion-panel-header__state-icon', contentClass]"
          :disabled="disabledIcon"
        >
          <template #tooltip>
            {{ !isActive() ? $t('Common.unfold') : $t('Common.foldup') }}
          </template>
        </w-arrow-down>
        <div class="w-expansion-panel-header__append">
          <slot />
        </div>
      </div>
    </template>

    <template #actions>
      <div class="w-expansion-panel-header__actions d-flex">
        <slot name="actions" />
      </div>
    </template>
  </v-expansion-panel-header>
</template>

<script>
import { VExpansionPanelHeader } from 'vuetify/lib';

export default {
  name: 'WorkExpansionPanelHeader',
  props: {
    ...VExpansionPanelHeader.options.props,
    disabled: { type: Boolean, default: false },
    disabledIcon: { type: Boolean, default: false },
    contentClass: { type: String, default: 'mr-2' },
  },
  methods: {
    isActive() {
      return this?.$refs['expansion-panel-header']?.isActive
    },
    getIsActiveClass() {
      return this.isActive() ? 'w-expansion-panel-header__is-active' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables';

.w-expansion-panel-header__is-active {
  ::v-deep .w-expansion-panel-header__state-icon {
    transform: rotate(-180deg);
    margin-right: 2 !important;
  }
}

.w-expansion-panel-header {
  line-height: 1.5;
  padding:#{$grid-gutter};
  overflow-x: auto;
  .v-btn {
    color: $icon-color !important;
  }
  * {
    scrollbar-width: none;
  }
  /*** ### OTHER BROWSERS ### ***/
  ::-webkit-scrollbar {
    display: none;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .w-expansion-panel-header {
    padding: 0 $quater-grid-gutter;
    min-height: 3rem;
  }
}

.w-expansion-panel-header__default {
  width: auto;
  display: flex;
  align-items: center;

  @supports (-moz-appearance: none) {
    // otherwise buggy scrollbar in firefox
    overflow-x: scroll;
  }
}

.w-expansion-panel-header__append {
  width: max-content;
}
</style>
